import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/client/components/base/card";

const TrackersPage = () => (
    <div className="mx-auto w-full max-w-7xl px-4 py-8 sm:px-6">
        <h1 className="text-2xl font-semibold tracking-tight">Trackers</h1>
        <p className="mt-1 text-sm text-muted-foreground">
            Live trackers for your portfolio, positions, orders and market moves.
        </p>

        <Card className="mt-6">
            <CardHeader>
                <CardTitle>Coming soon</CardTitle>
                <CardDescription>Trackers are under construction.</CardDescription>
            </CardHeader>
            <CardContent>
                <ul className="grid gap-1.5 text-sm text-muted-foreground">
                    <li>Portfolio and P&L tracker</li>
                    <li>Open positions and orders</li>
                    <li>Live price feeds</li>
                </ul>
            </CardContent>
        </Card>
    </div>
);

export default TrackersPage;
